export default __webpack_public_path__ + "static/media/yantramanav.regular.55a06057.ttf";